<div class="modal-body px-6" style="padding-top:40px; padding-bottom: 40px;">
  <div class="row mb-6">
    <div class="col text-center mb-4">
      <img src="../../assets/Gen-AI-loader.gif" alt="img-fluid">
    </div>
  </div>
  <div class="row mb-3">
    <div class="col text-center ">
      <p class="font-weight-600 f-24 mb-2">Our <span class="genai-text">Gen AI</span> is analyzing your Ideal Profile.</p>
    </div>
  </div>
  <div class="col position-relative mb-4 gen-ai" >

    <div class="progress">
      <div class="progress-bar" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="max-width: 100%">
      </div>
    </div>
  </div>
    <div class="row mb-3">
      <div class="col text-center">
        <p class="font-weight-500 f-14 mb-2">{{progressValue}}% Completed</p>
      </div>
    </div>
  <div class="row">
    <div class="col ml-2">
      <p 
        class="f-12 text-484b59 mb-3 d-flex" 
        [ngClass]="{'font-weight-500 f-16': (progressValue>9 && progressValue<30)}"
      >
        <span class="mr-3">
          <i class="fas fa-file" [ngClass]="{'text-webbtree-green': progressValue == 20}"></i>
        </span> 
        <span>Analyzing Ideal Candidate Profile</span>
      </p>

      <p 
        class="f-12 text-484b59 mb-3 d-flex" 
        [ngClass]="{'font-weight-500 f-16':  (progressValue>29 && progressValue<50)}"
      >
        <span class="mr-3">
          <i class="fas fa-briefcase" [ngClass]="{'text-webbtree-green': progressValue == 40}"></i>
        </span> 
        <span>Identifying Appropriate Job Titles and Necessary Skills</span>
      </p>

      <p 
        class="f-12 text-484b59 mb-3 d-flex"  
        [ngClass]="{'font-weight-500 f-16':  (progressValue>49 && progressValue<70)}"
      >
        <span class="mr-3">
          <i class="fas fa-building" [ngClass]="{'text-webbtree-green': progressValue == 60}"></i>
        </span> 
        <span>Identifying Similar Companies</span>
      </p>

      <p 
        class="f-12 text-484b59 mb-3 d-flex"  
        [ngClass]="{'font-weight-500 f-16':  (progressValue>69 && progressValue<90)}"
      >
        <span class="mr-3">
          <i class="fas fa-user" [ngClass]="{'text-webbtree-green': progressValue == 80}"></i>
        </span> 
        <span>Creating Your Tailored Candidate Pool</span>
      </p>

      <p 
        class="f-12 text-484b59 d-flex mb-0"  
        [ngClass]="{'font-weight-500 f-16':  (progressValue>89)}"
      >
        <span class="mr-3">
          <i class="fas fa-users" [ngClass]="{'text-webbtree-green': progressValue == 100}"></i>
        </span> 
        <span>Final Step: Finding Similar Profiles</span>
      </p>

    </div>
  </div>
</div>